import StaffPortal from './StaffPortal';

export default StaffPortal;
